import { render, staticRenderFns } from "./Concierges.vue?vue&type=template&id=5e5605bc"
import script from "./Concierges.vue?vue&type=script&lang=js"
export * from "./Concierges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports